import React, { useCallback } from 'react';
import MenuCard from './MenuCard';
import { resolveSelectedVariant } from '../services/tableService';
import type { MenuGridProps, FoodItem, Variant, CartItem } from '../types';

const MenuGrid: React.FC<MenuGridProps> = ({
    items,
    category,
    tableCart,
    variantMap,
    onAddToCart,
    onUpdateQty,
    onVariantChange,
}) => {
    const renderCard = useCallback(
        ([name, item]: [string, FoodItem]) => {
            const compositeKey = `${category}-${name}`;
            const selVar = resolveSelectedVariant(variantMap, compositeKey, item);
            const cartKey = `${compositeKey}-${selVar.value}`;
            const cartItem = tableCart[cartKey] as CartItem | null;
            const inCartQty = cartItem?.selected || 0;

            return (
                <MenuCard
                    key={`${category}-${name}`}
                    item={item}
                    category={category}
                    name={name}
                    selectedVariant={selVar}
                    inCartQty={inCartQty}
                    onAdd={() => onAddToCart(item, category, name)}
                    onIncrement={() => cartItem && onUpdateQty(cartKey, cartItem, 1)}
                    onDecrement={() => cartItem && onUpdateQty(cartKey, cartItem, -1)}
                    onVariantChange={(v: Variant) => onVariantChange(compositeKey, v)}
                />
            );
        },
        [category, tableCart, variantMap, onAddToCart, onUpdateQty, onVariantChange],
    );

    if (items.length === 0) {
        return (
            <div className="posv2-menu-grid">
                <div className="posv2-empty">
                    <p>No items in this category</p>
                </div>
            </div>
        );
    }

    return (
        <div className="posv2-menu-grid">
            {items.map(renderCard)}
        </div>
    );
};

export default React.memo(MenuGrid);
